import Breadcrumb from '@/components/breadcrumb';
import { Button } from '@/components/ui/button';
import { useStore } from '@nanostores/react';
import { CircleDollarSign, FlaskConical, PlusIcon } from 'lucide-react';
// import { ExperimentListing } from './components/ExperimentListings';
// import { NewExperimentDrawer } from './components/NewExperimentDrawer';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuItem, DropdownMenuGroup, DropdownMenuContent } from '@/components/ui/dropdown-menu';
import { TasksListing } from './components/TaskListing';


export type ManageTasksProps = {
  organizationId: string;
};

export const ManageTasks = ({
  organizationId,
}: ManageTasksProps) => {
  const [showDrawer, setShowDrawer] = useState(false);
  const org = useStore($org);

  const pages = [
    {
      label: org?.name ?? 'Organizations',
      href: org?.name
        ? `/organization/${org?.id}/tasks`
        : '/organizations',
    },
    {
      label: 'Tasks',
      href: `/organization/${org?.id ?? ''}/tasks`,
    },
  ];

  return (
    <div>
      {/* Breadcrumb */}
      <h3 className="m-0 flex-1 p-0">
        <Breadcrumb pages={pages} />
      </h3>

      {/* Page Header with actions */}
      <div className=" mt-2 flex items-center justify-between space-y-2">
        <div>
          <h2 className="text-2xl font-bold tracking-tight">Tasks</h2>
          <p className="text-muted-foreground">
            {`List of tasks for ${org?.name}.`}
          </p>
        </div>
      </div>

      {/* Experiment list*/}
      <div className="mt-4 max-w-4xl">
        <TasksListing />
      </div>

    </div>
  );
};